var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useParams } from 'react-router-dom';
import { LoginType } from '@lucidlink/dto/validation';
import { Box, C, translate } from '@lucidlink/uicore';
import { AddWorkspaceButtonFeatureFlagProperties } from '#constants';
import { useAuthProvider } from '#context';
import { useIsEnabledFeatureFlag } from '#hooks';
import { isPendingMember } from '#services';
import { AddWorkspaceButton, WorkspaceBarItem } from './components';
import styles from './WorkspaceBar.module.css';
export const WorkspaceBar = ({ isExpanded, workspaces }) => {
    _react_refresh_temp_2();
    const { workspaceId } = useParams();
    const { currentUser } = useAuthProvider();
    const { isEnabledFeatureFlag } = useIsEnabledFeatureFlag();
    const isAddWorkspaceFeatureFlagEnabled = isEnabledFeatureFlag(AddWorkspaceButtonFeatureFlagProperties);
    const isUserLoginTypeSso = currentUser?.loginType === LoginType.SSO;
    const shouldShowAddWorkspaceButton = isAddWorkspaceFeatureFlagEnabled && isUserLoginTypeSso;
    return (_jsx(Box, { ariaLabel: translate('Workspaces'), as: "nav", className: C(styles.Bar, !isExpanded && styles.Hidden), "data-testid": "workspace-bar", hasBorder: false, inert: !isExpanded, isFullHeight: true, kind: "level1", orientation: "vertical", children: _jsxs(Box, { align: "center", className: styles.OverflowFix, orientation: "vertical", scrollableY: true, children: [workspaces.map((workspaceData) => {
                    const isSelected = workspaceId === workspaceData.id;
                    return (_jsx(WorkspaceBarItem, { isPending: isPendingMember(workspaceData, currentUser), isSelected: isSelected, name: workspaceData.name, workspaceId: workspaceData.id }, `${workspaceData.id}-${workspaceData.name}`));
                }), shouldShowAddWorkspaceButton && _jsx(AddWorkspaceButton, {})] }) }));
};
_react_refresh_temp_1 = WorkspaceBar;
$RefreshReg$(_react_refresh_temp_1, "WorkspaceBar");
_react_refresh_temp_2(WorkspaceBar, "WqriGGnvWQ2OI95lhYvW1/iFDo0=", false, () => [useParams, useAuthProvider, useIsEnabledFeatureFlag]);
